export var profileActivityFeed = {
  member: {
    id: '456',
    name: 'Jane Smith',
    recentActivity: {
      pageInfo: {
        hasNextPage: false,
        endCursor: '8'
      },
      edges: [{
        cursor: '1',
        node: {
          id: '1',
          __typename: 'TimelineEntryAnsweredCorrectly',
          description: 'Answered correctly',
          pointsEarned: 11,
          createdAt: '2021-10-21T04:00:00Z',
          challenge: {
            id: '3',
            headline: 'Some challenge with a quiz stage'
          }
        }
      }, {
        cursor: '2',
        node: {
          id: '2',
          __typename: 'TimelineEntryAnsweredIncorrectly',
          description: 'Answered incorrectly',
          createdAt: '2021-10-21T04:00:00Z',
          pointsEarned: null,
          challenge: {
            id: '3',
            headline: 'Some challenge with a quiz stage'
          }
        }
      }, {
        cursor: '3',
        node: {
          id: '3',
          __typename: 'TimelineEntryLiked',
          description: 'Tester liked Mohammad Yakubadv2\'s response to <a href="%7B%7Bchallenge_url%7D%7D" rel="nofollow">yakub public challenge 2022 dec 7</a>: <p>upload video</p>: https://static.influitive.com/files/raw/Nt145oXdT36HjCMsFd4i_first_snow_winnipeg_2022.mp4\n<p>upload a file</p>: https://cdn.filestackcontent.com/2kbct6ORjSgFnn71xT2x#sample.pdf\n<p>How are you?</p>: uploading everthing needed\n<p>upload image</p>: https://static.influitive.com/files/images/slgBVYmQQI6W5Wou9peA_cheese ball.jpeg\n<p>upload another file</p>: https://cdn.filestackcontent.com/TTGgex6TfaIOo56C8uTp#landlady stats.pdf',
          createdAt: '2021-10-19T03:00:00Z',
          pointsEarned: null,
          challenge: {
            id: '4',
            headline: 'yakub public challenge 2022 dec 7'
          }
        }
      }, {
        cursor: '4',
        node: {
          id: '4',
          __typename: 'TimelineEntryLeftAComment',
          description: 'Mohammad Yakubadv2 commented on Mohammad Yakubadv2\'s response to <a href="%7B%7Bchallenge_url%7D%7D" rel="nofollow">yakub public challenge 2022 dec 7</a> challenge: <em>commenting again3</em>',
          createdAt: '2022-10-19T21:30:00Z',
          pointsEarned: 0,
          challenge: {
            id: '4',
            headline: 'yakub public challenge 2022 dec 7'
          }
        }
      }, {
        cursor: '5',
        node: {
          id: '5',
          __typename: 'TimelineEntryCompletedChallenge',
          description: 'Completed a challenge',
          pointsEarned: 10,
          createdAt: '2021-10-01T04:00:00Z',
          challenge: {
            id: '2',
            headline: 'Some challenge'
          }
        }
      }, {
        cursor: '6',
        node: {
          id: '6',
          __typename: 'TimelineEntryEarnedBadge',
          description: 'Earned the badge <strong>Badge name</strong>',
          pointsEarned: 12,
          createdAt: '2021-10-11T04:00:00Z'
        }
      }, {
        cursor: '7',
        node: {
          id: '7',
          __typename: 'TimelineEntryAdvancedLevel',
          description: "You've advanced to a new level!",
          pointsEarned: 13,
          createdAt: '2021-09-30T04:00:00Z'
        }
      }, {
        cursor: '8',
        node: {
          id: '8',
          __typename: 'TimelineEntryCompletedChallenge',
          description: 'Completed a challenge',
          pointsEarned: 16,
          createdAt: '2021-06-30T04:00:00Z',
          challenge: {
            id: '1',
            headline: 'Challenge headline'
          }
        }
      }]
    }
  }
};